import React from 'react';
import { Link } from 'react-router-dom';
import './LandingFooter.css';

const LandingFooter = () => {
  const currentYear = new Date().getFullYear();

  const productLinks = [
    { label: 'Research Papers', to: '/explore' },
    { label: 'Research Labs', to: '/rooms' },
    { label: 'Communities', to: '/communities' },
    { label: 'Courses', to: '/courses' },
    { label: 'Messaging', to: '/messaging' },
    { label: 'Workshops', to: '/workshops' },
  ];

  const resourceLinks = [
    { label: 'Documentation', to: '/docs' },
    { label: 'Research Guides', to: '/guides' },
    { label: 'Blog', to: '/blog' },
    { label: 'Help Center', to: '/help' },
  ];

  const companyLinks = [
    { label: 'About', to: '/about' },
    { label: 'Careers', to: '/careers' },
    { label: 'Contact', to: '/contact' },
  ];

  const legalLinks = [
    { label: 'Privacy Policy', to: '/legal/privacy-policy' },
    { label: 'Terms of Service', to: '/legal/terms-of-service' },
    { label: 'Cookie Policy', to: '/legal/cookie-policy' },
  ];

  return (
    <footer className="lfooter">
      <div className="lfooter__inner">

        {/* ── Top: Brand + Link Columns ── */}
        <div className="lfooter__top">

          {/* Brand Column */}
          <div className="lfooter__brand">
            <Link to="/" className="lfooter__logo">
              research pro
            </Link>
            <p className="lfooter__tagline">
              The research platform for teams who move fast.
            </p>
            <div className="lfooter__socials">
              {/* Twitter / X */}
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="lfooter__social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </a>
              {/* GitHub */}
              <a href="https://github.com" target="_blank" rel="noopener noreferrer" aria-label="GitHub" className="lfooter__social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.202 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.943.359.309.678.92.678 1.855 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" />
                </svg>
              </a>
              {/* LinkedIn */}
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="lfooter__social-link">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                </svg>
              </a>
            </div>
          </div>

          {/* Link Columns */}
          <div className="lfooter__columns">
            <div className="lfooter__column">
              <h4 className="lfooter__column-title">Product</h4>
              <ul className="lfooter__list">
                {productLinks.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="lfooter__link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lfooter__column">
              <h4 className="lfooter__column-title">Resources</h4>
              <ul className="lfooter__list">
                {resourceLinks.map((link) => (
                  <li key={link.label}>
                    {link.external ? (
                      <a href={link.to} className="lfooter__link" target="_blank" rel="noopener noreferrer">
                        {link.label}
                        <span className="lfooter__external-dot" />
                      </a>
                    ) : (
                      <Link to={link.to} className="lfooter__link">{link.label}</Link>
                    )}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lfooter__column">
              <h4 className="lfooter__column-title">Company</h4>
              <ul className="lfooter__list">
                {companyLinks.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="lfooter__link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="lfooter__column">
              <h4 className="lfooter__column-title">Legal</h4>
              <ul className="lfooter__list">
                {legalLinks.map((link) => (
                  <li key={link.label}>
                    <Link to={link.to} className="lfooter__link">{link.label}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* ── Divider ── */}
        <div className="lfooter__divider" />

        {/* ── Bottom Bar ── */}
        <div className="lfooter__bottom">
          <p className="lfooter__copyright">
            &copy; {currentYear} ResearchPro. All rights reserved.
          </p>
          <div className="lfooter__bottom-right">
          </div>
        </div>

      </div>
    </footer>
  );
};

export default LandingFooter;
